/**
 * The 500ms pause between tapping a flagged choice and the wizard moving on by itself. The server
 * dispatches `guide-chose`; the browser holds the advance so a mistap can be corrected, and only
 * follows through when the caregiver is still on the screen the tap happened on — a manual
 * Continue (form submit) or a re-pick disarms or restarts the timer.
 */
export default () => ({
    advance: null,

    arm($wire) {
        clearTimeout(this.advance)

        const pickedOn = $wire.index

        this.advance = setTimeout(() => {
            if ($wire.index === pickedOn) {
                $wire.next()
            }
        }, 500)
    },

    disarm() {
        clearTimeout(this.advance)
    },
})
